import { vnTemplate } from "./vnTemplate";
export class autoRefresh_template extends vnTemplate {
    getTemplateHtml() {
        return `
                <div class="toggleWrapper">
                    <input type="checkbox" name="toggle1" class="mobileToggle" id="toggle1" checked data-bind="disable: autoRefreshDisabled, checked: toggleAutoRefresh, click: onClickToggleAutoRefresh">
                    <label for="toggle1"></label>
                </div>
            `;
    }
    getTemplateName() {
        return "autoRefresh-template";
    }
    getMainElementType() {
        return "div";
    }
    getMainElementClasses() {
        return ["autoRefresh"];
    }
    buildViewModel() {
        let huit_neuf_this = this;
        // define the viewmodel data/ functions
        return {
            refreshFrequency: ko.observable(5000),
            toggleAutoRefresh: ko.observable(true),
            autoRefreshDisabled: ko.observable(false),
            callRefresh: function (data, event) { huit_neuf_this.callRefresh(); },
            onClickToggleAutoRefresh: function (data, event) { huit_neuf_this.onClickToggleAutoRefresh(); return true; },
            setRefreshFrequency: function (data, event) { huit_neuf_this.setRefreshFrequency(data); }
        };
    }
    onClickToggleAutoRefresh() {
        this.callRefresh();
        if (this.caller)
            this.caller.filterAutoRefreshStatusOnChange();
    }
    callRefresh() {
        clearTimeout(this.autoRefreshTimerId);
        let _myThis = this;
        if (this.getTemplateViewModel().toggleAutoRefresh()) {
            this.autoRefreshTimerId = setTimeout(function () {
                if (!document.getElementById(_myThis.idElement)) {
                    clearTimeout(_myThis.autoRefreshTimerId);
                }
                else {
                    _myThis.autoRefresh();
                }
            }, this.getTemplateViewModel().refreshFrequency());
        }
    }
    autoRefresh() {
        this.caller.autoRefresh();
    }
    setRefreshFrequency(frequency) {
        this.getTemplateViewModel().refreshFrequency(frequency);
    }
    setToggleAutoRefresh(toggleAutoRefresh) {
        this.getTemplateViewModel().toggleAutoRefresh(toggleAutoRefresh);
        this.callRefresh();
    }
}
